<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-房产-添加
    -->
    <el-dialog
    title="添加房产"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="120px">
      <div class="common-form">添加房产</div>

      <!-- 新增字段：所属物业 -->
      <el-form-item label="所属物业" prop="supply_id">
        <el-select v-model="form.supply_id" placeholder="请选择所属物业" class="max-w460">
          <el-option 
            v-for="item in supplyList" 
            :key="item.supply_id" 
            :label="item.name" 
            :value="item.supply_id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="房产名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入房产名称" class="max-w460"></el-input>
      </el-form-item>
    
     
        <el-form-item label="详细信息" >
        <el-button size="small" type="primary" @click="addOrder" >新增</el-button>
        <el-table :data="info"  border size="mini" style="width: 100%;margin-top: 20px;">



        <el-table-column prop="name" label="楼层"   >
            <template v-slot="scope">
                <div>
                  <div class="d-s-c">
                    <el-input style="width: 650px;" type="text" v-model="scope.row.lc"  placeholder="请输入楼层"></el-input>
                 
                  </div>
                </div>
              </template>
        </el-table-column>     


            
       <el-table-column prop="name" label="房号" >
              <template v-slot="scope">
                <div>
                  <div class="d-s-c">
                    <el-input style="width: 650px;" type="textarea" v-model="scope.row.context"  placeholder="请输入房号"></el-input>
                 
                  </div>
                </div>
              </template>
        </el-table-column>    
        
        
        <el-table-column prop="name" label="选择维修人员" >
              <template v-slot="scope">
                <div class="d-s-s d-c">
          <el-button @click="openWeixiu" icon="el-icon-plus">选择维修人员</el-button>
          <ul class="d-s-s select-user" >
            <li v-if="item.user_id" v-for="(item,index) in weixiu" class="mr10 d-c-c d-c p-10-0">
              <img :src="item.avatarUrl" class="radius" width="30" height="30" />
              <p class="lh18 ww100 text-ellipsis">{{item.nickName}}</p>
            </li>
          </ul>
        </div>
              </template>
        </el-table-column>     




  
       <el-table-column prop="name" label="操作"  width="100">
              <template v-slot="scope">
                <div style="color: blue;" @click="delOrder(scope.$index)">删除</div>

              </template>
            </el-table-column>
          </el-table>
      </el-form-item> 
     
     
     
     
      <!-- <el-form-item label="楼层" prop="floor_numbers">
        <el-input 
          v-model="form.floor_numbers" 
          placeholder="请输入楼层，多个楼层用逗号分隔，例如：1,2" 
          class="max-w460">
        </el-input>
        <div class="tip-text">多个楼层请用逗号分隔</div>
      </el-form-item> -->
      <!-- 新增字段：房号（可填写多个） -->
      <!-- <el-form-item label="房号" prop="room_numbers">
        <el-input 
          v-model="form.room_numbers" 
          placeholder="请输入房号，多个房号用逗号分隔，例如：101,102,201" 
          class="max-w460">
        </el-input>
        <div class="tip-text">多个房号请用逗号分隔</div>
      </el-form-item> -->

      <!-- 新增字段：预期通知天数 -->
      <el-form-item label="预期通知天数" prop="notice_days">
        <el-input-number 
          v-model="form.notice_days" 
          :min="0" 
          :max="30" 
          placeholder="请输入预期通知天数"
          class="max-w200">
        </el-input-number>
        <span class="tip-text">天（逾期前多少天通知）</span>
      </el-form-item>

      <!-- 状态选择 -->
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">常住</el-radio>
          <el-radio :label="2">空置</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 选择管家 -->
      <el-form-item label="管家" :rules="[{required: true,message: '请选择管家'}]">
        <div class="d-s-s d-c">
          <el-button @click="openStaff" icon="el-icon-plus">选择管家</el-button>
          <ul class="d-s-s select-user">
            <li v-if="staff.staff_id" class="mr10 d-c-c d-c p-10-0">
              <img :src="staff.image_url" class="radius" width="30" height="30" />
              <p class="lh18 ww100 text-ellipsis">{{staff.name}}</p>
            </li>
          </ul>
        </div>
      </el-form-item>

      <!-- 费用信息 -->
      <!-- <el-form-item label="基础费用/月">
        <div class="fee-container">
          <el-form-item label="物业费用" prop="property_fee" class="fee-item">
            <el-input v-model="form.property_fee" placeholder="请输入物业费用" class="max-w200">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="水费" prop="water_fee" class="fee-item">
            <el-input v-model="form.water_fee" placeholder="请输入水费" class="max-w200">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="电费" prop="electric_fee" class="fee-item">
            <el-input v-model="form.electric_fee" placeholder="请输入电费" class="max-w200">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="车位费" prop="parking_fee" class="fee-item">
            <el-input v-model="form.parking_fee" placeholder="请输入车位费" class="max-w200">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </div>
      </el-form-item> -->

      <!-- 违约金信息 -->
      <!-- <el-form-item label="违约金/天">
        <div class="fee-container">
          <el-form-item label="物业违约金" prop="property_penalty" class="fee-item">
            <el-input v-model="form.property_penalty" placeholder="物业违约金" class="max-w200">
              <template slot="append">元/天</template>
            </el-input>
          </el-form-item>
          <el-form-item label="水费违约金" prop="water_penalty" class="fee-item">
            <el-input v-model="form.water_penalty" placeholder="水费违约金" class="max-w200">
              <template slot="append">元/天</template>
            </el-input>
          </el-form-item>
          <el-form-item label="电费违约金" prop="electric_penalty" class="fee-item">
            <el-input v-model="form.electric_penalty" placeholder="电费违约金" class="max-w200">
              <template slot="append">元/天</template>
            </el-input>
          </el-form-item>
          <el-form-item label="车位费违约金" prop="parking_penalty" class="fee-item">
            <el-input v-model="form.parking_penalty" placeholder="车位费违约金" class="max-w200">
              <template slot="append">元/天</template>
            </el-input>
          </el-form-item>
        </div>
      </el-form-item> -->

      <el-form-item label="房产bannar：" prop="bannar">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.bannar">
            <transition-group>
              <div v-for="(item, index) in form.bannar" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="file_path"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('bannar')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="房产图片：" prop="image">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image">
            <transition-group>
              <div v-for="(item, index) in form.image" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="file_path"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('album')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="房产介绍">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    
    <!-- 选择管家组件 -->
    <Staff :storeId="Number(form.staff_id)" :is_open="isOpenStaff"
    :supply_id="form.supply_id"
          :multi="false" @close="closeStaffFunc"></Staff>
    <!-- 选择维修人员组件 -->
    <Weixiu :storeId="Number(form.user_id)" :is_open="isopenWeixiu"
    :user_id="form.user_id"
          :multi="true" @close="closeWeixiuFunc"></Weixiu>



  </div>
</el-dialog>
</template>

<script>
import Real_estateApi from '@/api/real_estate.js';
import SupplyApi from '@/api/supply.js'; // 引入物业API
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import Staff from '@/components/user/Staff.vue';
import Weixiu from '@/components/user/GetRepair.vue';

export default {
  components: {
     Upload,
     draggable,
     Uediter,
     Staff,
     Weixiu
  },
  data() {
    // 费用验证规则
    const validateFee = (rule, value, callback) => {
      if (value && isNaN(value)) {
        callback(new Error('请输入有效的数字'));
      } else if (value && value < 0) {
        callback(new Error('费用不能为负数'));
      } else {
        callback();
      }
    };
    
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:[],
        sort:50,
        intro:"",
        bannar:[],
        status: 1, // 1:常住, 2:空置
        staff_id: 0,
        supply_id: '', // 所属物业ID
        floor_numbers:'',
        room_numbers: '', // 房号
        notice_days: 7, // 预期通知天数，默认7天
        property_fee: '',
        water_fee: '',
        electric_fee: '',
        parking_fee: '',
        property_penalty: '', // 物业违约金
        water_penalty: '', // 水费违约金
        electric_penalty: '', // 电费违约金
        parking_penalty: '' // 车位费违约金
      },
      info:[],
      // 物业列表
      supplyList: [],
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入房产名称', trigger: 'blur' }],
        supply_id: [{ required: true, message: '请选择所属物业', trigger: 'change' }],
        room_numbers: [{ required: true, message: '请输入房号', trigger: 'blur' }],
        notice_days: [{ required: true, message: '请输入预期通知天数', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        property_fee: [{ validator: validateFee, trigger: 'blur' }],
        water_fee: [{ validator: validateFee, trigger: 'blur' }],
        electric_fee: [{ validator: validateFee, trigger: 'blur' }],
        parking_fee: [{ validator: validateFee, trigger: 'blur' }],
        property_penalty: [{ validator: validateFee, trigger: 'blur' }],
        water_penalty: [{ validator: validateFee, trigger: 'blur' }],
        electric_penalty: [{ validator: validateFee, trigger: 'blur' }],
        parking_penalty: [{ validator: validateFee, trigger: 'blur' }]
      },
      dialogVisible:false,
      isProductUpload:false,
      code:"album",
      // 选择用户开关
      isOpenStaff: false,
      isopenWeixiu:false,
      staff: {},
      weixiu:[]
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getSupplyList(); // 获取物业列表
  },
  props: ["open_add"],
  methods: {
   addOrder(){
        this.info.push({
          "code":this.randomString(8,this.randomString(6,0)),
          "sort":50,
          "name":"",
        });
      },
   delOrder(index){
        this.info.splice(index,1)
    },
    /*获取物业列表*/
    getSupplyList() {
      let self = this;
      SupplyApi.supplyList({}, true)
        .then(data => {
          self.supplyList = data.data.list.data || [];
        })
        .catch(error => {
          console.error('获取物业列表失败:', error);
        });
    },
    
    /*打开获取用户*/
    openStaff() {
      this.isOpenStaff = true;
    },
    
    /*关闭获取用户*/
    closeStaffFunc(e) {
      if (e.type != 'error') {
        this.form.staff_id = e.params.staff_id;
        this.staff = e.params;
      }
      this.isOpenStaff = false;
    },



        /*打开获取用户*/
    openWeixiu() {
      this.isopenWeixiu = true;
    },
    
    /*关闭获取用户*/
    closeWeixiuFunc(e) {
      if (e.type != 'error') {
        this.form.weixius = e.params;//存user_id
        this.weixiu = e.params;
      }
      this.isopenWeixiu = false;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    cancelFunc() {
      this.dialogFormVisible("error");
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      
      if(form.image.length <= 0){
        self.$message({
          message: "请上传图片",
          type: 'error'
        });
        return;
      }
      
      form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Real_estateApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*打开上传图片*/
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      } else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

/* 费用信息样式 */
.fee-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.fee-item {
  margin-bottom: 0;
}

.max-w200 {
  max-width: 200px;
}

.max-w460 {
  max-width: 460px;
}

.select-user {
  margin-top: 10px;
}

.select-user li {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 5px 10px;
  background-color: #f5f7fa;
}

.tip-text {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

.el-form-item {
  margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/real_estate/index/part/add.vue